module.exports = __webpack_public_path__ + "static/media/sell_finish_service_make_3.f3a69271.jpg";